import { useContext } from "react";
import { Container } from "../components/common-components";
import { FormContextMA } from "../form-context";
import { PrescriptionDetails } from "../components/PrescriptionDetails";
import { getTreatmentDrugs } from "../../patient/clinical-services/service-steps/treatment/data";

export const PrescriptionForm = ({}) => {
  const { treatment, alertData } = useContext(FormContextMA);
  const drugs = getTreatmentDrugs(treatment) || [];

  // Render `PrescriptionDetails` per drug; if none and `EndServiceAndRefer` is true, render one empty `PrescriptionDetails` so referral content is visible.
  if (drugs.length > 0) {
    return (
      <div className="space-y-20">
        {drugs.map((d) => (
          <Container key={d.id || Math.random()}>
            <PrescriptionDetails drug={d} />
          </Container>
        ))}
      </div>
    );
  }

  if (alertData?.EndServiceAndRefer) {
    return (
      <div className="space-y-20">
        <Container>
          <PrescriptionDetails drug={{}} />
        </Container>
      </div>
    );
  }

  return <div className="space-y-20" />;
};
